import React from "react";
import { Alert } from "@ufginsurance/ui-kit";

const CyberCustomMessage = ({ effectiveDate, productMatrix }) => {
  const { beazleyCyberEffectiveDate } = productMatrix || {};

  if (!effectiveDate || !productMatrix || !beazleyCyberEffectiveDate)
    return null;

  const date = new Date(effectiveDate);
  const beazleyDate = new Date(beazleyCyberEffectiveDate);

  if (date >= beazleyDate)
    return (
      <Alert
        type="warning"
        dismissible={false}
        className="mb-2 oq__custom-cyber-message"
      >
        <div className="mb-1">
          <b>Please Note:</b>
        </div>
        At this time Cyber will not be automatically added to your quote. If you
        are interested in a quote for our new Cyber product that takes effect on
        4/15/2025, please contact your underwriter.
      </Alert>
    );
};

export default CyberCustomMessage;
